<script>
import StoreAPIKeyForm from '@app/components/StoreAPIKeyForm.vue';
import TalkizyAPI from '@app/services/API/Talkizy';

export default {
  components: {
    StoreAPIKeyForm,
  },
  data() {
    return {
      talkizyLoading: false,
      talkizyPoll: null,
    };
  },
  head: {
    title: 'APIs développeur - Paramètres',
  },
  beforeDestroy() {
    if (this.talkizyPoll) {
      clearInterval(this.talkizyPoll);
    }
  },
  methods: {
    async openTalkizy() {
      this.talkizyLoading = true;
      try {
        const { redirect_url } = await TalkizyAPI.getSSORegisterUrl();
        const popup = window.open(redirect_url, 'talkizy-sso', 'width=600,height=700');

        if (!popup) {
          this.talkizyLoading = false;
          this.$buefy.toast.open({ message: 'Veuillez autoriser les popups pour continuer.', type: 'is-warning' });
          return;
        }

        this.talkizyPoll = setInterval(async() => {
          if (popup.closed) {
            clearInterval(this.talkizyPoll);
            this.talkizyPoll = null;
            try {
              await this.$store.dispatch('auth/fetch');
            } catch (e) {
              this.$buefy.toast.open({ message: 'Une erreur est survenue.', type: 'is-danger' });
            } finally {
              this.talkizyLoading = false;
            }
          }
        }, 1000);
      } catch (e) {
        this.talkizyLoading = false;
        this.$buefy.toast.open({ message: 'Une erreur est survenue.', type: 'is-danger' });
      }
    },
  },
};
</script>

<template>
  <div>
    <StoreAPIKeyForm />
  </div>
</template>
